export default __webpack_public_path__ + "static/media/sketch.fb91c555.png";